import { getPanchang, type PanchangResponse } from "@/lib/api/panchang";
import { getTodayISTDateString } from "@/lib/ist-date";

/**
 * Tara Balam is counted from the seeker's janma nakshatra to TODAY'S transit
 * nakshatra, so the transit is a live engine fact — never a constant. The
 * engine returns the verdict for all 27 nakshatras at once (`bala.tarabalam`),
 * which is why this page can serve every seeker from one URL without a form.
 */
export const TARA_BALAM_DEFAULT_CITY = {
  name: "New Delhi",
  latitude: 28.6139,
  longitude: 77.209,
  timezone: "Asia/Kolkata",
} as const;

export async function getTaraBalamSnapshot(): Promise<PanchangResponse | null> {
  try {
    return await getPanchang({
      date: getTodayISTDateString(),
      latitude: TARA_BALAM_DEFAULT_CITY.latitude,
      longitude: TARA_BALAM_DEFAULT_CITY.longitude,
      tz: TARA_BALAM_DEFAULT_CITY.timezone,
    });
  } catch {
    return null;
  }
}
